import { useEffect, useState } from 'react';
import { fetchProducts, fetchTestimonials } from '../services/contentApi';
import { PRODUCTS as FALLBACK_PRODUCTS } from '../data/siteContent';

/* Module-level cache so the list is fetched once per session. */
let productsCache = null;
let testimonialsCache = null;

const fallbackProducts = FALLBACK_PRODUCTS.map((p, i) => ({ ...p, status: 'IN_DEVELOPMENT', displayOrder: i, published: true }));

/**
 * Products managed from the admin portal.
 * If the API cannot be reached, a built-in starter list is shown so the page is never blank.
 */
export function useProducts() {
  const [products, setProducts] = useState(productsCache || fallbackProducts);
  const [loading, setLoading] = useState(!productsCache);

  useEffect(() => {
    if (productsCache) return undefined;
    let alive = true;
    fetchProducts()
      .then((list) => {
        productsCache = Array.isArray(list) ? list : [];
        if (alive) setProducts(productsCache);
      })
      .catch(() => { /* keep fallback */ })
      .finally(() => { if (alive) setLoading(false); });
    return () => { alive = false; };
  }, []);

  return { products, loading };
}

/** Published testimonials / proof (empty until the admin adds some). */
export function useTestimonials() {
  const [items, setItems] = useState(testimonialsCache || []);

  useEffect(() => {
    if (testimonialsCache) return undefined;
    let alive = true;
    fetchTestimonials()
      .then((list) => {
        testimonialsCache = Array.isArray(list) ? list : [];
        if (alive) setItems(testimonialsCache);
      })
      .catch(() => {});
    return () => { alive = false; };
  }, []);

  return items;
}
